angular.module("cadastralMunicipalDel.components", []).component("cadastralMunicipalDel", {
    templateUrl: "ng/components/delegationRequest/cadastralMunicipalDel/cadastralMunicipalDel.view.html",
    bindings: {
        richiestePostVendita: "=",
        validatePage: "&"
    },
    controllerAs: "cadastralMunicipalDelCtrl",
    controller: function CadastralMunicipalDel(
        $arcService,
        $typeDomainService,
        $rootScope,
        DettaglioImmobiliare,
        Sede,
        DatiCatastali
    ) {
        var self = this;

        self.$onInit = function () {
            self.$rootScope = $rootScope;
            self.supportModel = {
                contractSelected: [],
                contractList: [],
                dropdownDelega: [],
                delegaSelected: [],
                type: "cadastralMunicipalDelegation",
                delega: null,
                validityUpdateDelegato: false,
                causale: null,
                tipo: null,
                dettaglioList: []
            }
            self.supportModel.delega = self.richiestePostVendita.metadata.delega;
            self.supportModel.listToUpdate = self.supportModel.delega.contratti;

            self.supportModel.listToUpdate.forEach(function (element) {
                if (element.dettaglioImmobiliare.length) {
                    element.selected = true;
                    self.supportModel.dettaglioList = element.dettaglioImmobiliare;
                } else {
                    getDettaglioReddito();
                }
            });

            getDelegaType();
            checkValidityPage();
        };

        self.handleChange = function (property, value) {
            switch (property) {
                case 'updateDelegato':
                    self.supportModel.validityUpdateDelegato = value;
                    break;
                case "contracts":
                    self.supportModel.contractSelected = value;
                    getDettaglioReddito(value.numeroContratto, value.numeroModulo);
                    break;
                case "dettaglio":
                    self.supportModel.listToUpdate.forEach(function (contratto) {
                        value.forEach(function (dettaglio) {
                            //se c'è almeno un dettaglio selezionato, contratto.selected = true 
                            if (dettaglio.numero == contratto.numero &&
                                dettaglio.modulo == contratto.modulo &&
                                dettaglio.selected) {
                                contratto.selected = true;
                                contratto.dettaglioImmobiliare = value;
                            }
                        });
                    });
                    break;
                case "tipo":
                    self.supportModel.delega[property] = value.name;
                    break;
                default:
                    self.supportModel.delega[property] = value;
                    break;
            }
            checkValidityPage();
        }

        self.exportValiditySede = function (validity) {
            self.validitySede = validity;
        }

        var checkValidityPage = function () {
            var delega = self.supportModel.delega.tipo;

            var dettaglioImmo = false;
            self.supportModel.delega.contratti.forEach(function (contratto) {
                dettaglioImmo = contratto.dettaglioImmobiliare.some(function (dettaglio) {
                    return dettaglio.selected == true
                });
            });

            if (delega && dettaglioImmo && self.supportModel.validityUpdateDelegato) {
                self.validatePage({
                    validity: true
                });
                self.supportModel.delega.contratti = self.supportModel.listToUpdate;
                self.richiestePostVendita.metadata.delega = self.supportModel.delega;
            } else {
                self.validatePage({
                    validity: false
                });
            }
        }

        var getDelegaType = function () {
            $typeDomainService.getDomainSet("RI_POSTVENDITA", "TIPO_DELEGA").then(function (response) {
                self.supportModel.dropdownDelega = response.domainList;
                if (self.richiestePostVendita.metadata.delega && self.richiestePostVendita.metadata.delega.tipo) {
                    self.supportModel.delegaSelected.name = self.supportModel.dropdownDelega.find(function (element) {
                        return element.name == self.richiestePostVendita.metadata.delega.tipo
                    })
                }
            });
        }

        var getDettaglioReddito = function () {
            self.isPending = true;
            self.supportModel.listToUpdate.forEach(function (contratto) {
                $arcService.
                getDettaglioReddito(contratto.numero, contratto.modulo)
                    .then(function (response) {
                        if (response) {
                            response.dettaglioImmobiliare.forEach(function (dettaglioResp) {
                                var dettaglio = DettaglioImmobiliare.build();
                                dettaglio.numero = contratto.numero;
                                dettaglio.modulo = contratto.modulo;
                                dettaglio.indirizzo = Sede.build(dettaglioResp.indirizzo);
                                dettaglio.datiCatastali = DatiCatastali.build(dettaglioResp.datiCatastali);
                                dettaglio.selected = true;
                                contratto.dettaglioImmobiliare.push(dettaglio);
                            });

                            self.supportModel.dettaglioList = contratto.dettaglioImmobiliare;
                            self.isPending = false;
                        }
                    })
            })
            checkValidityPage();
        }
    }
});